import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col } from 'antd';
import { useNavigate } from "react-router-dom";
import LoginModal from "./modals/log-in";
import SignupModal from "./modals/sign-up";
import ConnectToRemote from "../Home/modals/connect-to-remote";
import bot from "../common/img/bot.png"
import robollaLogo from "../common/img/robollalogo.png"
import { useAppContext, changeHostIP, setToken, setUserId, APP_ACTIONS } from "../../context/appContext";
import loginUser from "../common/helpers/login-user";
import signupUser from "../common/helpers/signup-user";
import jwt_decode from "jwt-decode";
import fetchUser from "../common/helpers/fetch-user";

const Login = ({ setHasAuth, setChangeRemoteHost }) => {
    const {
        dispatch,
    } = useAppContext();

    const [displayLogin, setDisplayLogin] = useState(false);
    const [displaySignup, setDisplaySignup] = useState(false);
    const [displayConnectHost, setDisplayConnectHost] = useState(false);

    const handleLogin = async (data) => {
        const res = await loginUser(data);

        if (res.error) {
            message.error(res.error)
            return;
        }
        if (res.token) {
            setToken(res.token);
            localStorage.setItem('jwt-token', res.token);
            setUserId(jwt_decode(res.token).id)
            message.success("Logged in successfully")

            fetchUser().then(user => {
                dispatch({
                    type: APP_ACTIONS.SET_USER,
                    payload: user,
                })
            })


            setHasAuth(true);
        }
    }

    const handleSignup = async (data) => {
        const { email, password, password2 } = data;

        if (!validateEmail(email)) {
            message.error("invalid email");
            return;
        }
        if (password !== password2) {
            message.error("passwords don't match")
            return;
        }
        const res = await signupUser({ email, password });
        if (res.error) {
            message.error(res.error)
            return;
        }
        setDisplaySignup(false);
        if (res.activated) {
            handleLogin({ email, password });
        } else {
            message.warning("Account created, waiting for admin's approval")
        }
    }

    const handleConnectHost = (data) => {
        message.loading({ content: 'Waiting...', key: 'remoteHostLoading', duration: 0 });
        changeHostIP(data).then(res => {
            localStorage.setItem('remote-host', data.host_ip);
            message.destroy('remoteHostLoading');
            message.success({ content: "connected to the remote host" });
            setChangeRemoteHost(prev => !prev);

        }).catch(err => {
            message.destroy('remoteHostLoading');
            message.error({ content: 'error, could not connect' })
        })

        setDisplayConnectHost(false);
    }

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    return (
        <>
            {displayLogin && <LoginModal displayLogin={displayLogin} setDisplayLogin={setDisplayLogin} onLogin={handleLogin} />}
            {displaySignup && <SignupModal displaySignup={displaySignup} setDisplaySignup={setDisplaySignup} onSignup={handleSignup} />}
            {displayConnectHost && <ConnectToRemote displayConnectHost={displayConnectHost} setDisplayConnectHost={setDisplayConnectHost} onConnectHost={handleConnectHost} />}

            <div style={{ textAlign: "center", marginTop: 40, height: 400 }}>
                {/* <img src={bot} style={{ marginBottom: 10 }} /> */}
                <img src={robollaLogo} style={{ marginBottom: 10, width: 300, height: 150 }} />
                <div style={{ color: "#4D4D4D", fontWeight: "bold" }} >ON DEMAND CRYPTO LIQUIDITY SYSTEMS</div>
                <span style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", }} >
                    <div style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#4D4D4D", height: 1, width: 60, marginTop: 30, marginBottom: 30 }}>
                    </div>
                </span>
                <div>
                    <Button onClick={() => { setDisplaySignup(true); }} style={{ backgroundColor: "white", color: "black", fontWeight: "600", width: 120, height: 50, marginTop: 10, marginRight: 25 }} type="default">SIGN UP</Button>
                    <Button onClick={() => { setDisplayLogin(true); }} style={{ backgroundColor: "white", color: "black", fontWeight: "600", width: 120, height: 50 }} type="default">LOGIN</Button>
                    <div style={{ marginTop: 50 }}>
                        <Button onClick={() => { setDisplayConnectHost(true) }} style={{ backgroundColor: "#161616", color: "white", height: 50 }} type="default">CONNECT TO REMOTE HOST</Button>
                    </div>

                </div>

            </div>
        </>
    );
};

export default Login;